<template>
    <ul
        class="flex items-center justify-center flex-nowrap text-nowrap w-fit"
        :class="[{'gap-36': !withChevron && !container}, container ? 'rounded py-24 px-56 shadow ' + (contrast ? 'bg-primary-5' : 'bg-white') : 'p-16']"
    >
        <li
            v-for="(step, i) in steps"
            class="flex-1 flex items-center">
            <template v-if="!step.hidden">
                <div
                    class="flex items-center gap-4"
                    :class="[step.disabled ? 'cursor-default' : 'cursor-pointer']"
                    @click="step.disabled ? undefined : currentStep = i + 1"
                >
                    <svg-icon
                        v-if="indicatorIcon(i + 1)"
                        :type="indicatorIcon(i + 1)"
                        class="w-16 h-16"
                        :class="iconColor(i + 1)"
                    />
                    <span :class="textClass(i + 1)">{{ step.title }}</span>
                </div>
                <svg-icon
                    v-if="(container || withChevron) && i + 1 !== steps.length"
                    type="keyboard-arrow-right"
                    class="w-18 h-18 mx-16"
                    :class="iconColor(i + 1)"
                />
            </template>
        </li>
    </ul>
</template>

<script>
import SvgIcon from "./ui/SvgIcon";
export default {
    components: {SvgIcon},
    props: {
        // Expected objects:
        // {
        //   title: "Title you'll see on the step",
        //   disabled: false,
        //   icon: "Name of the icon",
        //   hidden: false
        // }
        steps: Array,
        value: Number,
        withChevron: Boolean,
        container: Boolean,
        contrast: Boolean,
    },
    computed: {
        currentStep: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {
        indicatorIcon(step) {
            if (this.currentStep > step) {
                return 'check-circle-filled';
            } else {
                return 'radio-button-unchecked';
            }
        },
        textClass(step) {
            let classes = ['first-letter:uppercase'];
            if (this.currentStep > step) {
                classes.push('font-semibold');
            }

            if (this.currentStep >= step) {
                classes.push('text-black');
            } else {
                if (this.container && this.contrast) {
                    classes.push('text-primary-80');
                } else {
                    classes.push('text-primary-60');
                }
            }

            return classes;
        },
        iconColor(step) {
            if (this.currentStep >= step) {
                return 'fill-primary';
            } else {
                if (this.container && this.contrast) {
                    return 'fill-primary-80';
                } else {
                    return 'fill-primary-60';
                }
            }
        }
    }
}
</script>

<style scoped>
.arrow-right {
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;

    border-left: 20px solid #58CC47;
}
</style>
